module.exports = __webpack_public_path__ + "static/about-background-2-07515e68446e6175cef0d5f4543e9ff1.jpg";